import { useState } from "react";
import { AccordionProps } from "../../types/app";

function Accordion({ title, children }: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="overflow-hidden py-3 max-w-[650px] mx-auto">
      <button
        className="flex items-center justify-between w-full px-4 py-2 bg-white"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h1 className="font-medium lg:font-semibold text-lg lg:text-2xl text-primaryBlack">
          {title}
        </h1>
        <svg
          className={`h-6 w-6 transition-transform transform text-primary ${
            isOpen ? "rotate-180" : ""
          }`}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill="currentColor" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>
      {isOpen && (
        <div className="p-4 ease-in transform duration-500">{children}</div>
      )}
    </div>
  );
}

export default Accordion;
